'use client';
import React from 'react';
import Link from 'next/link';
import DropDownTextMenu from './navbar/DropDownTextMenu';
import useAuthenticatedUser from '@dr-pam/common-components/Hooks/useAuthenticatedUser';
import QuizButton from '../quiz/QuizButton';

export type ParentsMenuBaseProps = {
	active: boolean;
	onToggle: () => void;
	onNavigate: () => void;
	/** Signed in with paid NDC access: this is their member menu, and the parent programs are a resource. */
	isProfessional?: boolean;
};

export default function ParentsOrMyPossumsMenu({
	active,
	onToggle,
	onNavigate,
	isProfessional = false,
}: ParentsMenuBaseProps) {
	const { user } = useAuthenticatedUser();
	const title = user ? 'my possums' : 'for parents';
	const firstName = user?.displayName?.split(' ')[0] ?? null;

	const containerClass = `parents-menu ${user ? 'parents-menu--authed' : 'parents-menu--guest'}${
		isProfessional ? ' parents-menu--professional' : ''
	}`;

	return (
		<>
			{user && firstName && (
				<h3 className="nav-greeting mobile-welcome">
					<span className="mobile-welcome__line">Welcome</span>
					<span className="mobile-welcome__name">{firstName}!</span>
				</h3>
			)}

			<DropDownTextMenu
				title={title}
				active={active}
				onToggle={onToggle}
				navItemClassName={user ? 'my-possums' : undefined}
			>
				<div className={containerClass}>
					<div className="parents-left">
						{user ? (
							<>
								{firstName && (
									<h3 className="nav-greeting desktop-welcome">
										{' '}
										Welcome, <span className="nav-greeting__name">{firstName}!</span>
									</h3>
								)}
								<Link className="nav-link" href="/dashboard" onClick={onNavigate}>
									{/* eslint-disable-next-line @next/next/no-img-element */}
									<img
										src="/images/icons/dark-icons/PossumsForParents.svg"
										height={30}
										width={30}
										alt=""
									/>
									my possums dashboard
								</Link>
							</>
						) : (
							<Link className="nav-link" href="/parents" onClick={onNavigate}>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="/images/icons/dark-icons/PossumsForParents.svg"
									height={30}
									width={30}
									alt=""
								/>
								parents home
							</Link>
						)}
					</div>

					<div className="parents-divider" aria-hidden />

					<div className="parents-right">
						{isProfessional && (
							<>
								<Link className="nav-link" href="/ndc-institute/calendar" onClick={onNavigate}>
									{/* eslint-disable-next-line @next/next/no-img-element */}
									<img
										src="/images/icons/dark-icons/CalendarEvents.svg"
										height={30}
										width={30}
										alt=""
									/>
									ndc institute calendar
								</Link>
								<Link
									className="nav-link"
									href="/ndc-institute/guest-speaker-events"
									onClick={onNavigate}
								>
									{/* eslint-disable-next-line @next/next/no-img-element */}
									<img
										src="/images/icons/dark-icons/GuestSpeakers.svg"
										height={30}
										width={30}
										alt=""
									/>
									guest speaker events
								</Link>
							</>
						)}

						<Link className="nav-link" href="/parents/programs" onClick={onNavigate}>
							{/* eslint-disable-next-line @next/next/no-img-element */}
							<img src="/images/icons/dark-icons/Library.svg" height={30} width={30} alt="library" />
							{isProfessional ? 'browse all parent programs' : 'browse all programs'}
						</Link>

						{!user && <QuizButton asLink className="nav-link" onClickCapture={onNavigate} />}

						<Link className="nav-link" href="/audio" onClick={onNavigate}>
							{/* eslint-disable-next-line @next/next/no-img-element */}
							<img
								src="/images/icons/dark-icons/OurProgramsInAudio.svg"
								height={30}
								width={30}
								alt="audio"
							/>
							{isProfessional ? 'parent programs in audio' : 'programs in audio'}
						</Link>

						{!isProfessional && (
							<Link className="nav-link" href="/parents/group-sessions" onClick={onNavigate}>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img
									src="/images/icons/dark-icons/GroupSessionsWithDrPam.svg"
									height={30}
									width={30}
									alt="group sessions"
								/>
								group sessions with dr pam
							</Link>
						)}
					</div>
				</div>
			</DropDownTextMenu>
		</>
	);
}
